import { Editor } from "slate";
import { Plugin } from "slate-react";

/**
 * Slate plugin to add a `toggle_${type}` command that calls the provided action
 */
export const AddToggleCommand = (type: string, action: (editor: Editor) => Editor): Plugin => ({
    commands: {
      [`toggle_${type}`]: action,
    },
  }
);
